import {Button, Lead, Radio, Slot, Text, Trail, Typography} from '@yandex-delivery/blocks'
import React from 'react'

import {Badge} from 'src/shared/components/desktop'
import {i18n} from 'src/shared/config'

import businessPackSrc from './assets/BusinessDepricated.svg'

type Props = {
  name: string
  onClick: VoidFunction
  checked?: boolean
}

export function Business({onClick, checked = false}: Props): React.ReactElement<Props> {
  return (
    <Slot size="l">
      <Lead
        // @ts-expect-error 😔 кривая типизация GWC, пропс наследуется вот Box
        justifyContent="initial"
        size="m"
      >
        <img alt="" height="24px" loading="lazy" src={businessPackSrc} width="36px" />
      </Lead>
      <Text>
        <Typography group="tight" pr="xs" variant="body2">
          {i18n('payment-type-modal.balance-list.title', 'Расчётный счёт') + ' '}
          <Badge label={i18n('form.order.badge.business', 'Бизнес')} />
        </Typography>
        <Typography color="minor" group="tight" variant="caption1">
          {i18n('payment-account.description', 'Работайте по договору, получайте счета и акты')}
        </Typography>
      </Text>
      <Trail>
        <Button onPress={onClick} shape="circle" size="xs" textVariant="caption1" variant="outline">
          {i18n('order-form.payments-widget.business.detail', 'Подробнее')}
        </Button>
      </Trail>
      <Trail ml="s">
        <Radio checked={checked} data-e2e="add-balance" onClick={onClick} />
      </Trail>
    </Slot>
  )
}
